// extracted by mini-css-extract-plugin
module.exports = {"form":"meB3oQwfkjbjf0_oKXr5"};